"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LIST_CATEGORY_KEY = 'base';
exports.LIST_COMPONENT_KEY = 'list';